import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
    const { pathname } = useLocation()

    // Use layout effect to scroll before the browser paints, ensuring the page starts at the top
    useLayoutEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    }, [pathname])

    return null
}

export default ScrollToTop
